
import Cookies from 'js-cookie'
var aes = require('./aes.js');
import config from '../config/config'

const TokenKey = 'Mp-Token-V3'

export function getToken() {
    return Cookies.get(TokenKey)
  }
  
  export function setToken(token) {
    return Cookies.set(TokenKey, token)
  }
  
  export function removeToken() {
    return Cookies.remove(TokenKey)
  }
  
  export function formatTimeUuid(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
  
    return `${[year, month, day].map(formatNumber).join('')}${[
      hour,
      minute,
      second
    ]
      .map(formatNumber)
      .join('')}`
  }
  
  export function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : `0${n}`
  }

  
 // aes加密
 export function aesEncrypt(str) {
    return aes.CryptoJS.AES.encrypt(str, aes.CryptoJS.enc.Utf8.parse(config.aes_key), {
      iv: aes.CryptoJS.enc.Utf8.parse(config.aes_iv),
      mode: aes.CryptoJS.mode.CBC,
      padding: aes.CryptoJS.pad.Pkcs7
    }).toString();
  }
  
  // aes解密
  export function aesDecrypt(str) {
    return aes.CryptoJS.AES.decrypt(str, aes.CryptoJS.enc.Utf8.parse(config.aes_key), {
      iv: aes.CryptoJS.enc.Utf8.parse(config.aes_iv),
      mode: aes.CryptoJS.mode.CBC,
      padding: aes.CryptoJS.pad.Pkcs7
    }).toString(aes.CryptoJS.enc.Utf8);
  }   